// @flow
import React, { Component } from 'react';
import ProductSimilar from 'components/product/ProductSimilar';
import * as SearchAPI from 'lib/api/search';

type Props = {
  productId: string,
};

type State = {
  products: Array<any>,
  loading: boolean,
  error: ?string,
};

class ProductSimilarContainer extends Component<Props, State> {
  state = {
    products: [],
    loading: true,
    error: null,
  };

  async componentDidMount() {
    await this.loadSimilarProducts();
  }

  async componentDidUpdate(prevProps: Props) {
    if (prevProps.productId !== this.props.productId) {
      await this.loadSimilarProducts();
    }
  }

  loadSimilarProducts = async () => {
    const { productId } = this.props;

    if (!productId) {
      this.setState({
        loading: false,
        error: 'Product ID is required',
      });
      return;
    }

    try {
      this.setState({ loading: true, error: null });
      const response = await SearchAPI.getSimilarProducts(productId, 10);
      this.setState({
        products: (response.data && response.data.hits) || response.data || [],
        loading: false,
      });
    } catch (e) {
      this.setState({
        products: [],
        loading: false,
        error: 'Failed to load similar products',
      });
    }
  };

  render() {
    const { products, loading } = this.state;

    return <ProductSimilar products={products} loading={loading} />;
  }
}

export default ProductSimilarContainer;



// WEBPACK FOOTER //
// ./src/containers/product/ProductSimilarContainer.js